<div class="card">
  <div class="card-body">
    @for (request of loanGroupRequest.requestList; track request) {
      <div class="mb-2">
        <app-all-loan-request-card [request]="request" [adminAccess]="allAdminAccess[request.CompanyId]"></app-all-loan-request-card>
      </div>
    }

    <div class="col d-flex align-items-end justify-content-end">
      <button class="btn" [ngClass]="{ 'btn-info': disallowProcess == false, 'btn-secondary': disallowProcess == true }" (click)="openReviewLoanRequestModal()">
        @if (clashedTickets != undefined && clashedTickets.length > 0) {
          <i class="fas fa-car-crash"></i>
          Review Clashed Requests
        } @else {
          Review Requests
        }
      </button>
    </div>
  </div>
</div>
